import React from 'react'
import { useParticipantDevice } from '../useParticipantActivity'
import Section from './Section'
import Fact from './Fact'
import EmptyNote from './EmptyNote'

const DeviceSection = ({ uid, hrvDevice }: { uid: string; hrvDevice?: string | null }) => {
  const device = useParticipantDevice(uid)

  if (device.status === 'loading') {
    return null
  }

  return (
    <Section title="App">
      {device.status === 'known' ? (
        <>
          <Fact label="App version" value={device.appVersion || '—'} />
          <Fact label="Device" value={device.device || '—'} />
        </>
      ) : (
        <EmptyNote>No device has opened the app yet.</EmptyNote>
      )}
      {hrvDevice && <Fact label="HRV device" value={hrvDevice} />}
    </Section>
  )
}

export default DeviceSection
